export default "__VITE_PUBLIC_ASSET__5c62b210__"